<!-- Full-screen Loader -->
<div class="global-loader-overlay" *ngIf="isLoading">
  <div class="global-spinner"></div>
</div>

<div class="auth-container">
  <!-- Left Panel: Brand, Value Prop & Conversion Trust Cards -->
  <div class="left-panel">
    <div class="brand" routerLink="/recruiter" style="cursor: pointer;">
      <img src="assets/images/beExpert.svg" alt="BeExpert Logo" class="brand-logo-img" />
      <span class="brand-text">BeExpert.ai</span>
    </div>

    <div class="hero-content">
      <h1 class="headline">
        Hire smarter.<br />Screen faster.<br />With BeExpert.ai
      </h1>
      <p class="subtitle">
        AI-powered assessments and interviews — every applicant comes
        pre-screened with scores and a detailed report.
      </p>

      <ul class="feature-list">
        <li>
          <span class="icon-check-wrapper">
            <svg class="check-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </span>
          Hire fresher and experienced talent from one dashboard
        </li>
        <li>
          <span class="icon-check-wrapper">
            <svg class="check-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </span>
          AI assessments and AI interviews score every candidate
        </li>
        <li>
          <span class="icon-check-wrapper">
            <svg class="check-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </span>
          Get a clear shortlist with scores, reports, and transcripts
        </li>
      </ul>

      <div class="feature-cards">
        <div class="feature-card">
          <div class="icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-briefcase">
              <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
            </svg>
          </div>
          <div class="fc-text">
            <h4>Post a Job in Minutes</h4>
            <p>Define the role, BeExpert.ai handles the screening</p>
          </div>
        </div>
        <div class="feature-card">
          <div class="icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-bar-chart-3">
              <path d="M3 3v18h18" />
              <path d="M18 17V9" />
              <path d="M13 17V5" />
              <path d="M8 17v-3" />
            </svg>
          </div>
          <div class="fc-text">
            <h4>Detailed Candidate Reports</h4>
            <p>Assessment + AI interview scores per applicant</p>
          </div>
        </div>
      </div>

      <!--<div class="stats">
        <div class="stat-item">
          <h3 class="stat-value">500+</h3>
          <p class="stat-label">Hiring companies</p>
        </div>
        <div class="stat-item">
          <h3 class="stat-value">100K+</h3>
          <p class="stat-label">Pre-screened candidates</p>
        </div>
        <div class="stat-item">
          <h3 class="stat-value">3 days</h3>
          <p class="stat-label">Avg. time to shortlist</p>
        </div>
      </div>-->
    </div>
  </div>

  <!-- Right Panel: Auth Floating Card -->
  <div class="right-panel">
    <div class="mobile-logo-header">
      <img src="assets/images/beExpert.svg" alt="BeExpert Logo" class="mobile-logo-img" />
      <span class="brand-text">BeExpert</span>
    </div>
    <div class="auth-card">
      <ng-container *ngIf="forgotPasswordStep === 0; else forgotPasswordTemplate">
        <ng-container *ngIf="isLogin; else signupTemplate">
          <!-- Login Form -->
          <div class="auth-header" *ngIf="!isVerifyingOtp">
            <h2>Recruiter Sign in</h2>
            <p>Sign in with your work email or mobile number</p>
          </div>

          <div class="auth-header" *ngIf="isVerifyingOtp">
            <h2>Verify OTP</h2>
            <p>Enter the 6-digit code we just sent</p>
          </div>

          <div class="toggle-group">
            <button class="toggle-btn" [class.active]="otpContext === 'login'" type="button"
              (click)="otpContext === 'register' ? toggleAuth('login') : null">
              Login
            </button>
            <button class="toggle-btn" [class.active]="otpContext === 'register'" type="button"
              (click)="otpContext === 'login' ? toggleAuth('signup') : null">
              Signup
            </button>
          </div>

          <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
            <!-- STATE 1: Enter identifier/password (Not verifying OTP) -->
            <ng-container *ngIf="!isVerifyingOtp">
              <div class="form-group" [class.has-error]="
                loginForm.get('identifier')?.touched &&
                loginForm.get('identifier')?.invalid
              ">
                <label>Work Email / Mobile Number</label>
                <input type="text" formControlName="identifier" placeholder="you@company.com or 10-digit mobile"
                  autocomplete="username" (input)="onIdentifierInput($event, 'identifier', loginForm)" />
                <div class="error-message" *ngIf="
                  loginForm.get('identifier')?.touched &&
                  loginForm.get('identifier')?.invalid
                ">
                  <span *ngIf="loginForm.get('identifier')?.errors?.['required']">Email or Mobile Number is
                    required.</span>
                  <span *ngIf="loginForm.get('identifier')?.errors?.['invalidPhoneLength']">Mobile number must be
                    exactly 10 digits.</span>
                  <span *ngIf="loginForm.get('identifier')?.errors?.['invalidPhoneStart']">Mobile number must start with
                    6, 7, 8, or 9.</span>
                  <span *ngIf="loginForm.get('identifier')?.errors?.['invalidPhone']">Please enter a valid mobile
                    number.</span>
                  <span *ngIf="loginForm.get('identifier')?.errors?.['invalidEmail']">Please enter a valid email
                    address.</span>
                </div>
              </div>

              <!-- Password Method -->
              <div class="form-group" *ngIf="loginMethod === 'password'" [class.has-error]="
                loginForm.get('password')?.touched &&
                loginForm.get('password')?.invalid
              ">
                <label>Password</label>
                <div class="input-with-icon" style="position: relative; display: flex; align-items: center;">
                  <input [type]="showPassword ? 'text' : 'password'" formControlName="password"
                    placeholder="Enter your password" style="width: 100%; padding-right: 40px;"
                    autocomplete="current-password" (keydown.space)="$event.preventDefault()" />
                  <button type="button" (click)="togglePasswordVisibility()" title="Toggle password visibility"
                    class="password-toggle-btn">
                    <i [class]="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                  </button>
                </div>
                <div class="error-message" *ngIf="
                  loginForm.get('password')?.touched &&
                  loginForm.get('password')?.invalid
                ">
                  <span *ngIf="loginForm.get('password')?.errors?.['required']">Password is required.</span>
                </div>
                <div style="text-align: right; margin-top: 8px;">
                  <a (click)="goToForgotPassword()"
                    style="color: #1f1b58; font-weight: 700; font-size: 0.85rem; cursor: pointer; text-decoration: none;">Forgot
                    password?</a>
                </div>
              </div>

              <!-- Submit button (Sign In or Send OTP) -->
              <button type="submit" class="submit-btn" [disabled]="loginForm.invalid">
                <svg *ngIf="loginMethod === 'otp'" class="btn-icon" xmlns="http://www.w3.org/2000/svg" width="16"
                  height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <rect width="20" height="16" x="2" y="4" rx="2" />
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                </svg>
                <svg *ngIf="loginMethod === 'password'" class="btn-icon" xmlns="http://www.w3.org/2000/svg" width="16"
                  height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                {{ loginMethod === 'password' ? 'Sign in' : 'Send OTP' }}
              </button>

              <!-- OR Divider -->
              <div class="or-divider">
                <span>OR</span>
              </div>

              <!-- Switch Method Button -->
              <button type="button" class="switch-method-btn" (click)="
                switchLoginMethod(loginMethod === 'password' ? 'otp' : 'password')
              ">
                <svg *ngIf="loginMethod === 'password'" class="btn-icon" xmlns="http://www.w3.org/2000/svg" width="16"
                  height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4a6.5 6.5 0 1 0-4-4Z" />
                  <circle cx="16.5" cy="7.5" r=".5" />
                </svg>
                <svg *ngIf="loginMethod === 'otp'" class="btn-icon" xmlns="http://www.w3.org/2000/svg" width="16"
                  height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                Login with {{ loginMethod === 'password' ? 'OTP' : 'password' }}
              </button>
            </ng-container>

            <!-- STATE 2: Verify OTP -->
            <ng-container *ngIf="isVerifyingOtp">
              <div class="form-group" [class.has-error]="
                loginForm.get('otp')?.touched && loginForm.get('otp')?.invalid
              ">
                <label>Enter 6-digit OTP</label>
                <p class="otp-hint-text">
                  Sent to <span class="highlight">{{ otpTarget }}</span>
                </p>
                <input type="text" formControlName="otp" placeholder="enter 6-digit otp" maxlength="6"
                  autocomplete="one-time-code" />
                <div class="error-message" *ngIf="
                  loginForm.get('otp')?.touched && loginForm.get('otp')?.invalid
                ">
                  <span *ngIf="loginForm.get('otp')?.errors?.['required']">OTP is required.</span>
                  <span *ngIf="loginForm.get('otp')?.errors?.['pattern']">OTP must be exactly 6 digits.</span>
                  <span *ngIf="loginForm.get('otp')?.errors?.['incorrect']">Invalid OTP. Please try again.</span>
                </div>
              </div>

              <!-- Verify & Sign in Button -->
              <button type="submit" class="submit-btn" [disabled]="loginForm.get('otp')?.invalid">
                Verify & Sign in &nbsp;&rsaquo;
              </button>

              <!-- Change Number/Email Link and Resend OTP -->
              <div class="change-target-wrapper" style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 15px;
              ">
                <button type="button" class="change-target-btn" (click)="resendOtp()">
                  Resend OTP
                </button>
                <button type="button" class="change-target-btn" (click)="changeOtpTarget()">
                  &larr; Change email/number
                </button>
              </div>
            </ng-container>
          </form>

          <div class="footer-link">
            <p>
              New here?
              <a (click)="toggleAuth('signup')">Create a company account</a>
            </p>
          </div>
        </ng-container>

        <ng-template #signupTemplate>
          <!-- Signup Form -->
          <div class="auth-header">
            <h2>Create company account</h2>
            <p>Tell us about your company to get started</p>
          </div>

          <div class="toggle-group">
            <button class="toggle-btn" type="button" (click)="toggleAuth('login')">
              Login
            </button>
            <button class="toggle-btn active" type="button">Signup</button>
          </div>

          <form [formGroup]="signupForm" (ngSubmit)="onSignup()">
            <div class="form-group" [class.has-error]="
              signupForm.get('company_name')?.touched &&
              signupForm.get('company_name')?.invalid
            ">
              <label>Company Name <span class="required">*</span></label>
              <input type="text" formControlName="company_name" placeholder="Acme Pvt. Ltd." />
              <div class="error-message" *ngIf="
                signupForm.get('company_name')?.touched &&
                signupForm.get('company_name')?.invalid
              ">
                <span *ngIf="signupForm.get('company_name')?.errors?.['required']">Company Name is required.</span>
                <span *ngIf="
                  signupForm.get('company_name')?.errors?.['minlength'] ||
                  signupForm.get('company_name')?.errors?.['maxlength']
                ">Company Name must be between 2 and 100 characters.</span>
                <span *ngIf="
                  signupForm.get('company_name')?.errors?.['pattern'] &&
                  !signupForm.get('company_name')?.errors?.['minlength'] &&
                  !signupForm.get('company_name')?.errors?.['maxlength']
                ">Invalid Company Name.</span>
              </div>
            </div>

            <div class="form-group" [class.has-error]="
              signupForm.get('company_url')?.touched &&
              signupForm.get('company_url')?.invalid
            ">
              <label>Company URL <span class="required">*</span></label>
              <input type="url" formControlName="company_url" placeholder="https://acme.com" />
              <div class="error-message" *ngIf="
                signupForm.get('company_url')?.touched &&
                signupForm.get('company_url')?.invalid
              ">
                <span *ngIf="signupForm.get('company_url')?.errors?.['required']">Company URL is required.</span>
                <span *ngIf="signupForm.get('company_url')?.errors?.['pattern']">Enter a valid Company URL.</span>
              </div>
            </div>

            <div class="form-group" [class.has-error]="
              signupForm.get('industry')?.touched &&
              signupForm.get('industry')?.invalid
            ">
              <label>Industry <span class="required">*</span></label>
              <div class="select-wrapper">
                <select formControlName="industry">
                  <option value="" disabled selected>Select Industry</option>
                  <option value="Information Technology">Information Technology</option>
                  <option value="Education / EdTech">Education / EdTech</option>
                  <option value="Healthcare & MedTech">Healthcare & MedTech</option>
                  <option value="FinTech & Banking">FinTech & Banking</option>
                  <option value="Retail & E-commerce">Retail & E-commerce</option>
                  <option value="Recruitment & HRTech">Recruitment & HRTech</option>
                  <option value="Real Estate & PropTech">Real Estate & PropTech</option>
                  <option value="Logistics & Supply Chain">Logistics & Supply Chain</option>
                  <option value="Travel & Hospitality">Travel & Hospitality</option>
                  <option value="Manufacturing">Manufacturing</option>
                  <option value="Automotive">Automotive</option>
                  <option value="Media & Entertainment">Media & Entertainment</option>
                  <option value="Food & Restaurant Industry">Food & Restaurant Industry</option>
                  <option value="Fitness & Wellness">Fitness & Wellness</option>
                  <option value="Insurance">Insurance</option>
                  <option value="LegalTech">LegalTech</option>
                  <option value="SaaS & Software Products">SaaS & Software Products</option>
                  <option value="Other">Other (Please specify)</option>
                </select>
              </div>
              <div class="error-message" *ngIf="
                signupForm.get('industry')?.touched &&
                signupForm.get('industry')?.invalid
              ">
                <span *ngIf="signupForm.get('industry')?.errors?.['required']">Please select an Industry.</span>
              </div>
              
              <!-- Custom Industry Input -->
              <div
                class="custom-category-input animate-fade-in mt-3"
                *ngIf="signupForm.get('industry')?.value === 'Other'"
              >
                <input
                  type="text"
                  placeholder="Enter custom industry"
                  formControlName="custom_industry"
                  class="standard-input-element"
                />
                <ng-container *ngIf="signupForm.get('custom_industry')?.touched">
                  <div class="error-message">
                    <span *ngIf="signupForm.get('custom_industry')?.errors?.['required']">
                      Custom industry is required.
                    </span>
                    <span *ngIf="signupForm.get('custom_industry')?.errors?.['minlength'] || signupForm.get('custom_industry')?.errors?.['maxlength']">
                      Industry name must be between 2 and 30 characters.
                    </span>
                    <span *ngIf="signupForm.get('custom_industry')?.errors?.['pattern'] && !signupForm.get('custom_industry')?.errors?.['minlength'] && !signupForm.get('custom_industry')?.errors?.['maxlength']">
                      Only alphabets are allowed.
                    </span>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="form-group" [class.has-error]="
              signupForm.get('poc_name')?.touched &&
              signupForm.get('poc_name')?.invalid
            ">
              <label>Point of Contact Name <span class="required">*</span></label>
              <input type="text" formControlName="poc_name" placeholder="Full name" autocomplete="name" />
              <div class="error-message" *ngIf="
                signupForm.get('poc_name')?.touched &&
                signupForm.get('poc_name')?.invalid
              ">
                <span *ngIf="signupForm.get('poc_name')?.errors?.['required']">Point of Contact Name is required.</span>
                <span *ngIf="
                  signupForm.get('poc_name')?.errors?.['minlength'] ||
                  signupForm.get('poc_name')?.errors?.['maxlength']
                ">Enter a valid name.</span>
                <span *ngIf="
                  signupForm.get('poc_name')?.errors?.['pattern'] &&
                  !signupForm.get('poc_name')?.errors?.['minlength'] &&
                  !signupForm.get('poc_name')?.errors?.['maxlength']
                ">Name should contain only alphabets.</span>
              </div>
            </div>

            <div class="form-group" [class.has-error]="
              signupForm.get('poc_email')?.touched &&
              signupForm.get('poc_email')?.invalid
            ">
              <label>Point of Contact Email <span class="required">*</span></label>
              <input type="email" formControlName="poc_email" placeholder="poc@acme.com" autocomplete="email" />
              <div class="error-message" *ngIf="
                signupForm.get('poc_email')?.touched &&
                signupForm.get('poc_email')?.invalid
              ">
                <span *ngIf="signupForm.get('poc_email')?.errors?.['required']">Email is required.</span>
                <span *ngIf="signupForm.get('poc_email')?.errors?.['email']">Enter a valid email address.</span>
              </div>
            </div>

            <div class="form-group" [class.has-error]="
              signupForm.get('official_email')?.touched &&
              signupForm.get('official_email')?.invalid
            ">
              <label>Official Email <span class="required">*</span></label>
              <input type="email" formControlName="official_email" placeholder="officialemail@acme.com"
                autocomplete="email" />
              <div class="error-message" *ngIf="
                signupForm.get('official_email')?.touched &&
                signupForm.get('official_email')?.invalid
              ">
                <span *ngIf="signupForm.get('official_email')?.errors?.['required']">Official Email is required.</span>
                <span *ngIf="signupForm.get('official_email')?.errors?.['email']">Enter a valid email address.</span>
              </div>
            </div>

            <div class="form-group" [class.has-error]="
              signupForm.get('password')?.touched &&
              signupForm.get('password')?.invalid
            ">
              <label>Password <span class="required">*</span></label>
              <div class="input-with-icon" style="position: relative; display: flex; align-items: center;">
                <input [type]="showPassword ? 'text' : 'password'" formControlName="password"
                  placeholder="Create a strong password" style="width: 100%; padding-right: 40px;"
                  (input)="stripSpaces($event, 'password', signupForm)" (keydown.space)="$event.preventDefault()" />
                <button type="button" (click)="togglePasswordVisibility()" title="Toggle password visibility"
                  class="password-toggle-btn">
                  <i [class]="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                </button>
              </div>
              <div class="error-message" *ngIf="
                signupForm.get('password')?.touched &&
                signupForm.get('password')?.invalid
              ">
                <ng-container *ngIf="signupForm.get('password')?.hasError('required'); else checkMinLength">
                  <span>Password is required.</span>
                </ng-container>
                <ng-template #checkMinLength>
                  <ng-container *ngIf="signupForm.get('password')?.hasError('minlength'); else checkMaxLength">
                    <span>Password must be at least 8 characters.</span>
                  </ng-container>
                </ng-template>
                <ng-template #checkMaxLength>
                  <ng-container *ngIf="signupForm.get('password')?.hasError('maxlength'); else checkStrength">
                    <span>Password cannot exceed 32 characters.</span>
                  </ng-container>
                </ng-template>
                <ng-template #checkStrength>
                  <ng-container *ngIf="signupForm.get('password')?.errors?.['passwordStrength'] as strengthErrors">
                    <ng-container *ngIf="!strengthErrors.hasNoSpaces; else checkUpper"><span>Must not contain
                        spaces.</span></ng-container>
                    <ng-template #checkUpper><ng-container
                        *ngIf="!strengthErrors.hasUpperCase; else checkLower"><span>Must contain at least one uppercase
                          letter (A-Z).</span></ng-container></ng-template>
                    <ng-template #checkLower><ng-container
                        *ngIf="!strengthErrors.hasLowerCase; else checkNum"><span>Must contain at least one lowercase
                          letter (a-z).</span></ng-container></ng-template>
                    <ng-template #checkNum><ng-container
                        *ngIf="!strengthErrors.hasNumeric; else checkSpecial"><span>Must contain at least one number
                          (0-9).</span></ng-container></ng-template>
                    <ng-template #checkSpecial><ng-container
                        *ngIf="!strengthErrors.hasSpecialChar; else checkWeak"><span>Must contain at least one special
                          character.</span></ng-container></ng-template>
                    <ng-template #checkWeak><ng-container *ngIf="!strengthErrors.isNotWeak"><span>Password is too
                          weak/common.</span></ng-container></ng-template>
                  </ng-container>
                </ng-template>
              </div>
              <div class="error-message"
                *ngIf="(signupForm.errors?.['passwordIsEmail'] || signupForm.errors?.['passwordIsName']) && signupForm.get('password')?.touched && signupForm.get('password')?.valid">
                <span *ngIf="signupForm.errors?.['passwordIsEmail']">Password cannot be the same as your email.</span>
                <span *ngIf="!signupForm.errors?.['passwordIsEmail'] && signupForm.errors?.['passwordIsName']">Password
                  cannot be the same as your name.</span>
              </div>
            </div>

            <div class="form-group" [class.has-error]="
              (signupForm.get('confirm_password')?.touched && signupForm.get('confirm_password')?.invalid) ||
              (signupForm.errors?.['passwordMismatch'] && signupForm.get('confirm_password')?.touched)
            ">
              <label>Confirm Password <span class="required">*</span></label>
              <div class="input-with-icon" style="position: relative; display: flex; align-items: center;">
                <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirm_password"
                  placeholder="Confirm your password" style="width: 100%; padding-right: 40px;"
                  (input)="stripSpaces($event, 'confirm_password', signupForm)" (keydown.space)="$event.preventDefault()" />
                <button type="button" (click)="toggleConfirmPasswordVisibility()"
                  title="Toggle confirm password visibility" class="password-toggle-btn">
                  <i [class]="showConfirmPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                </button>
              </div>
              <div class="error-message" *ngIf="signupForm.get('confirm_password')?.touched">
                <span *ngIf="signupForm.get('confirm_password')?.errors?.['required']">Please confirm your
                  password.</span>
                <span
                  *ngIf="!signupForm.get('confirm_password')?.errors?.['required'] && signupForm.errors?.['passwordMismatch']">Passwords
                  do not match.</span>
              </div>
            </div>

            <div class="form-group" [class.has-error]="
              signupForm.get('poc_phone')?.touched &&
              signupForm.get('poc_phone')?.invalid
            ">
              <label>Point of Contact Phone <span class="required">*</span></label>
              <div class="phone-input-group">
                <div class="country-selector">
                  <span>IN +91</span>
                  <svg class="chevron-down" xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round">
                    <path d="m6 9 6 6 6-6" />
                  </svg>
                </div>
                <input type="tel" formControlName="poc_phone" placeholder="10-digit number"
                  (input)="onPhoneInput($event, 'poc_phone', signupForm)"
                  (blur)="trimPhoneValue('poc_phone', signupForm)" />
              </div>
              <div class="error-message" *ngIf="
                signupForm.get('poc_phone')?.touched &&
                signupForm.get('poc_phone')?.invalid
              ">
                <span *ngIf="signupForm.get('poc_phone')?.errors?.['required']">Phone Number is required.</span>
                <span *ngIf="signupForm.get('poc_phone')?.errors?.['onlyDigits']">Phone Number should contain only
                  digits.</span>
                <span *ngIf="signupForm.get('poc_phone')?.errors?.['invalidPhone']">Enter a valid Phone Number.</span>
              </div>
            </div>

            <div class="info-alert">
              <svg class="alert-shield" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <path d="m9 12 2 2 4-4" />
              </svg>
              <p>
                We'll send a verification OTP to your point-of-contact email
                before you can continue.
              </p>
            </div>

            <button type="submit" class="submit-btn" [disabled]="signupForm.invalid">
              <svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect width="20" height="16" x="2" y="4" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
              </svg>
              Send Verification OTP
            </button>
          </form>
        </ng-template>
      </ng-container>

      <ng-template #forgotPasswordTemplate>
        <div class="auth-header" *ngIf="forgotPasswordStep !== 4">
          <ng-container *ngIf="forgotPasswordStep === 0">
            <h2>Recruiter Sign in</h2>
            <p>Sign in with your work email or mobile number</p>
          </ng-container>
          <ng-container *ngIf="forgotPasswordStep > 0">
            <h2>Reset Password</h2>
            <p>Recover access to your account</p>
          </ng-container>
        </div>

        <div class="toggle-group" *ngIf="forgotPasswordStep === 0">
          <button class="toggle-btn active" type="button" (click)="forgotPasswordBack()">Login</button>
          <button class="toggle-btn" type="button" (click)="forgotPasswordBack(); toggleAuth('signup')">Signup</button>
        </div>

        <!-- Back Link for Steps 1, 2, 3 -->
        <div style="margin-bottom: 20px; display: flex; align-items: center;" *ngIf="forgotPasswordStep < 4">
          <a class="fp-back-link" (click)="forgotPasswordBack()">
            <i class="bi bi-arrow-left"></i>
            <span>Back</span>
          </a>
        </div>

        <!-- STEP 1: ACCOUNT -->
        <ng-container *ngIf="forgotPasswordStep === 1">
          <p
            style="text-align: center; color: #6c757d; font-size: 0.95rem; margin-bottom: 24px; max-width: 300px; margin-left: auto; margin-right: auto;">
            Enter your work email and we'll send you a code to reset your password.
          </p>

          <form [formGroup]="forgotPasswordAccountForm" (ngSubmit)="submitForgotPasswordAccount()">
            <div class="form-group"
              [class.has-error]="forgotPasswordAccountForm.get('identifier')?.touched && forgotPasswordAccountForm.get('identifier')?.invalid">
              <label>Work Email</label>
              <input type="text" formControlName="identifier" placeholder="you@company.com" />
              <div class="error-message"
                *ngIf="forgotPasswordAccountForm.get('identifier')?.touched && forgotPasswordAccountForm.get('identifier')?.invalid">
                <span *ngIf="forgotPasswordAccountForm.get('identifier')?.errors?.['required']">Email is
                  required.</span>
                <span *ngIf="forgotPasswordAccountForm.get('identifier')?.errors?.['email']">Enter a valid email
                  address.</span>
              </div>
            </div>

            <button type="submit" class="submit-btn" [disabled]="forgotPasswordAccountForm.invalid"
              style="margin-top: 10px;">
              <svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              Send reset code
            </button>
          </form>
        </ng-container>

        <!-- STEP 2: VERIFY -->
        <ng-container *ngIf="forgotPasswordStep === 2">
          <p style="text-align: center; color: #6c757d; font-size: 0.95rem; margin-bottom: 8px;">
            Enter the 6-digit code we sent to your email
          </p>
          <p style="text-align: center; font-weight: 700; color: #1f1b58; margin-bottom: 24px;">
            {{ forgotPasswordEmailOrPhone }}
          </p>

          <form (submit)="submitForgotPasswordVerify(); $event.preventDefault()">
            <div class="form-group">
              <div class="fp-otp-inputs" style="display: flex; gap: 10px; justify-content: space-between;"
                (paste)="handleFpOtpPaste($event)">
                <input *ngFor="let v of forgotPasswordOtpValues; let i = index; trackBy: trackByIndex"
                  [id]="'fp-otp-input-' + i" type="text" maxlength="1" inputmode="numeric" autocomplete="one-time-code"
                  style="width: 45px; height: 50px; text-align: center; font-size: 1.2rem; padding: 0; border-radius: 8px; border: 1px solid #ced4da; background-color: #fcfcfc;"
                  [value]="forgotPasswordOtpValues[i]" (input)="handleFpOtpInput($event, i)"
                  (keydown)="handleFpKeyDown($event, i)" />
              </div>
            </div>

            <button type="submit" class="submit-btn" [disabled]="!isFpOtpFilled()" style="margin-top: 10px;">
              <svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
              Verify code
            </button>
          </form>

          <div style="text-align: center; font-size: 0.85rem; margin-top: 24px;">
            <span style="color: #6c757d;">Didn't get the code? </span>
            <button type="button" (click)="resendFpOtp()" [disabled]="resendCountdown > 0 || isResendingOtp"
              style="background: transparent; border: 1px solid #ced4da; padding: 4px 8px; border-radius: 4px; font-weight: 600;"
              [ngStyle]="{'color': resendCountdown > 0 || isResendingOtp ? '#adb5bd' : '#6c757d', 'cursor': resendCountdown > 0 || isResendingOtp ? 'not-allowed' : 'pointer'}">
              <ng-container *ngIf="isResendingOtp">Resending...</ng-container>
              <ng-container *ngIf="!isResendingOtp && resendCountdown > 0">Resend in {{ resendCountdown
                }}s</ng-container>
              <ng-container *ngIf="!isResendingOtp && resendCountdown === 0">Resend OTP</ng-container>
            </button>
          </div>
        </ng-container>

        <!-- STEP 3: RESET PASSWORD -->
        <ng-container *ngIf="forgotPasswordStep === 3">
          <p style="text-align: center; color: #6c757d; font-size: 0.95rem; margin-bottom: 8px;">
            Create a new password for
          </p>
          <p style="text-align: center; font-weight: 700; color: #1f1b58; margin-bottom: 24px;">
            {{ forgotPasswordEmailOrPhone }}
          </p>

          <form [formGroup]="forgotPasswordResetForm" (ngSubmit)="submitForgotPasswordReset()">
            <div class="form-group"
              [class.has-error]="forgotPasswordResetForm.get('password')?.touched && forgotPasswordResetForm.get('password')?.invalid">
              <label>New Password</label>
              <div class="input-with-icon" style="position: relative; display: flex; align-items: center;">
                <input [type]="showFpPassword ? 'text' : 'password'" formControlName="password"
                  placeholder="Enter new password" style="width: 100%; padding-right: 40px;"
                  (input)="stripSpaces($event, 'password', forgotPasswordResetForm)" (keydown.space)="$event.preventDefault()" />
                <button type="button" (click)="showFpPassword = !showFpPassword" title="Toggle password visibility"
                  class="password-toggle-btn">
                  <i [class]="showFpPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                </button>
              </div>
              <div class="error-message"
                *ngIf="forgotPasswordResetForm.get('password')?.invalid && (forgotPasswordResetForm.get('password')?.touched || forgotPasswordResetForm.get('password')?.dirty)">
                <span *ngIf="forgotPasswordResetForm.get('password')?.errors?.['required']">Password is required.</span>
                <span *ngIf="forgotPasswordResetForm.get('password')?.errors?.['minlength']">Minimum 8 characters
                  required.</span>
                <span
                  *ngIf="forgotPasswordResetForm.get('password')?.errors?.['passwordStrength'] && !forgotPasswordResetForm.get('password')?.errors?.['minlength']">Password
                  must contain uppercase, lowercase, numbers, and special characters.</span>
              </div>
            </div>

            <div class="form-group"
              [class.has-error]="(forgotPasswordResetForm.get('confirm_password')?.touched && forgotPasswordResetForm.get('confirm_password')?.invalid) || (forgotPasswordResetForm.errors?.['passwordMismatch'] && forgotPasswordResetForm.get('confirm_password')?.touched)">
              <label>Confirm New Password</label>
              <div class="input-with-icon" style="position: relative; display: flex; align-items: center;">
                <input [type]="showFpConfirmPassword ? 'text' : 'password'" formControlName="confirm_password"
                  placeholder="Re-enter new password" style="width: 100%; padding-right: 40px;"
                  (input)="stripSpaces($event, 'confirm_password', forgotPasswordResetForm)" (keydown.space)="$event.preventDefault()" />
                <button type="button" (click)="showFpConfirmPassword = !showFpConfirmPassword"
                  title="Toggle confirm password visibility" class="password-toggle-btn">
                  <i [class]="showFpConfirmPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                </button>
              </div>
              <div class="error-message" *ngIf="forgotPasswordResetForm.get('confirm_password')?.touched">
                <span *ngIf="forgotPasswordResetForm.get('confirm_password')?.errors?.['required']">Please confirm your
                  password.</span>
                <span
                  *ngIf="!forgotPasswordResetForm.get('confirm_password')?.errors?.['required'] && forgotPasswordResetForm.errors?.['passwordMismatch']">Passwords
                  do not match.</span>
              </div>
            </div>

            <button type="submit" class="submit-btn" [disabled]="forgotPasswordResetForm.invalid"
              style="margin-top: 10px;">
              <svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
              Reset password
            </button>
          </form>
        </ng-container>

        <!-- STEP 4: SUCCESS -->
        <ng-container *ngIf="forgotPasswordStep === 4">
          <div class="auth-header" style="text-align: center; margin-top: 40px; margin-bottom: 40px;">
            <div
              style="width: 56px; height: 56px; background-color: #d1f7e8; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px auto;">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="#0ea5e9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                style="stroke: #10b981;">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
            <h2>Password updated</h2>
            <p>Your password has been reset successfully.</p>

            <button class="submit-btn" (click)="forgotPasswordStep = 0" style="margin-top: 10px;">
              Back to login
            </button>
          </div>
        </ng-container>
      </ng-template>

    </div>
  </div>
</div>